var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-template',{attrs:{"table-config":_vm.tableConfig,"table-data":_vm.tableData,"total":_vm.total,"loading":_vm.loading,"current-page":_vm.page,"hasAdd":""},on:{"onChangePage":_vm.handleCurrentChange,"onHandle":_vm.handleClick,"onChange":_vm.onChange,"onAdd":_vm.onAdd}})
}
var staticRenderFns = []

export { render, staticRenderFns }